import request from 'superagent';
// withCredentials - CORS request using credentials with cookie-auth
export default function getRequestWithBoundHeaders(settee) {
    return {
        get(url) {
            return request('GET', url).withCredentials().set(settee);
        },
        post(url) {
            return request('POST', url).withCredentials().set(settee);
        },
        put(url) {
            return request('PUT', url).withCredentials().set(settee);
        },
        patch(url) {
            return request('PATCH', url).withCredentials().set(settee);
        },
        head(url) {
            return request('HEAD', url).withCredentials().set(settee);
        },
        del(url) {
            return request('DELETE', url).withCredentials().set(settee);
        },
        request(method, url) {
            return request(method, url).withCredentials().set(settee);
        },
    };
}
